import ResponsiveImage from '~/components/Image/ResponsiveImage'
import LeagueRankBg from '~/Leaderboard/components/LeagueRankBg'
import { LeaderboardUser } from '~/Leaderboard/types/leaderboard.types'

import { selectUserId } from '~/auth/slices/auth.slice'
import { useAppSelector } from '~/redux/hooks'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

export default function LeaderboardItem({
  item,
  rank,
  promotionSettings,
  leaderboardCapacity,
}: {
  item: LeaderboardUser
  rank: number
  promotionSettings: { promote: number; demote: number }
  leaderboardCapacity: number
}): React.ReactElement {
  const userId = useAppSelector(selectUserId) as number
  const isPromotion = rank <= promotionSettings.promote
  const isDemotion = rank > leaderboardCapacity - promotionSettings.demote

  const promotionColor = isPromotion ? 'text-green' : 'text-white'
  const demotionColor = isDemotion ? 'text-red' : 'text-white'
  const textColor = isPromotion ? promotionColor : demotionColor

  const isUnder13 = item.avatar?.includes('/under-13/')

  return (
    <div
      className={`flex items-center ${
        item.id === userId
          ? 'bg-gradient-purple-light-top font-semibold'
          : 'bg-gradient-purple-light-edges border-purple-light-top border'
      } h-12 w-full rounded-full mb-2 last:mb-0 sm:gap-2 lg:px-4`}
      style={{ maxWidth: 'calc(100vw - 24px)' }}
    >
      <div className="relative flex flex-col justify-center items-center w-16 text-center">
        <span className={`relative z-10 ${rank < 4 ? 'font-semibold' : ''}`}>{rank}</span>
        <LeagueRankBg rank={rank} />
      </div>

      <div className="flex-auto flex items-center max-w-1/2 md:max-w-3/4 mr-auto">
        <div className="flex items-center justify-center w-8 max-w-1/2 flex-shrink sm:w-10 h-8 sm:h-10 mr-2 overflow-hidden rounded-full">
          <ResponsiveImage
            alt="avatar"
            height={40}
            imageClassName={`bg-white ${item.avatar && !isUnder13 ? 'min-w-20 mt-5' : ''}`}
            mediaQuery={mediaQuery}
            srcKey={item.avatar ? item.avatar : 'avatar-portraits/hom-default-avatar.png'}
            width={40}
          />
        </div>
        <div
          className={`flex-shrink overflow-ellipsis overflow-hidden whitespace-nowrap ${
            item.id === userId ? 'text-white' : textColor
          }`}
        >
          {item.name}
        </div>
      </div>
      <div className="w-30 text-center">{item.xp}</div>
    </div>
  )
}
